import React from 'react';
import clsx from 'clsx';
import styles from './MoreMenuItem.module.scss';
import { emptyTranslation } from '@colonist/i18n';
import ChevronIcon from '@static/images/icon_arrow_down.svg';
import OutArrowIcon from '@static/images/icon_arrow_out.svg';
import { Image, T } from '@colonist/ui';
export const MoreMenuItem = ({ icon, showNotificationIcon = false, label, rightText, isExternalLink = false, onClick })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.menuItem,
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.iconWrapper
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.icon,
        image: {
            src: icon,
            alt: emptyTranslation
        }
    }), showNotificationIcon && /*#__PURE__*/ React.createElement("span", {
        className: styles.notificationDot
    })), /*#__PURE__*/ React.createElement("span", {
        className: styles.label
    }, /*#__PURE__*/ React.createElement(T, {
        id: label
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.right
    }, rightText && /*#__PURE__*/ React.createElement("span", {
        className: styles.rightText
    }, rightText), /*#__PURE__*/ React.createElement(Image, {
        className: clsx(styles.rightIcon, isExternalLink ? styles.outArrow : styles.chevron),
        image: {
            src: isExternalLink ? OutArrowIcon : ChevronIcon,
            alt: emptyTranslation
        }
    })));
